export default {
  init() {

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    const $categoriesMobileWrap = $('.component-news-categories-mobile-wrap');

    $('.categories-btn-mob').on('click', function() {
      // Open categories sidebar
      $categoriesMobileWrap.addClass('show');
      $('body').addClass('overflow-hidden');
    });

    $categoriesMobileWrap.find('.wrap-term').on('click', function() {
      // Clicked a category
      $(this).siblings('.wrap-term').removeClass('active');
      $(this).addClass('active');
    });

    $categoriesMobileWrap.find('.wrap-close').on('click', function() {
      // Close categories sidebar
      $categoriesMobileWrap.removeClass('show');
      $('body').removeClass('overflow-hidden');
    });

    $categoriesMobileWrap.find('.update-results-btn').on('click', function() {
      // Execute search
      const searchPath = $categoriesMobileWrap.find('.wrap-term.active').data('link');
      window.location = searchPath;
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateNews.js